/**
 * Created by shalin on 02/02/2017.
 */

var Iep = {
    currentItem: [],
    currentSelect: '',
    currentProperty: '',
    currentZzProperty: '',
    deletedId: '',
    newItemId:'',

    init: function() {
        Iep.bindTypeChange();
        Iep.bindPassportChange();
        Iep.bindLoadIepView();
        Iep.bindAddTarget();
        Iep.bindSavePropertyInModal();
        Iep.bindBuildDropdownInModal();
        Iep.bindBuildCheckboxInModal();
        Iep.bindDisableContextmenu();
        Iep.bindSetManage();
        Iep.bindAddProperty();
        Iep.bindManageIepPropertyButtons();
        Iep.bindManagePropertySave();
        Iep.bindDelete();
        Iep.bindCancel();
        Iep.bindPupilSelect();
        Iep.bindTargetSubmit();
        Iep.bindFocusCheck();
        Iep.bindSubmit();
        Iep.bindComments();
        Iep.bindTypeFilter();
    },

    bindTypeChange: function() {
        $('#type-select').on('select2:select', function (e) {
            var passport = $(e.currentTarget).find("option:selected").html().includes('Pupil Passport');
            if (!passport) {
                $('.pp-focus-area-dropdown').hide();
                $('.focus-area-dropdown').show();
                // resize select2 box after dom manipulation
                $('.select2-container', '.focus-area-dropdown').css('width', '100%');
            } else {
                $('.focus-area-dropdown').hide();
                $('.pp-focus-area-dropdown').show();
                // resize select2 box after dom manipulation
                $('.select2-container', '.pp-focus-area-dropdown').css('width', '100%');
            }
        });
    },

    bindPassportChange: function() {
        $('[id^=ppFocusArea-]').on('select2:select', function (e) {
            var subjectCategorySelect =
                $(this).closest('div.pp-focus-area-dropdown').nextAll().find('[id^=ppSubjectCategory-]').first();
            var levelSelect =
                $(this).closest('div.pp-focus-area-dropdown').nextAll().find('[id^=ppLevel-]').first();
            var statementSelect =
                $(this).closest('div.pp-focus-area-dropdown').nextAll().find('[id^=ppStatement-]').first();
            Iep.emptyDropdown(subjectCategorySelect, 'Subject Category');
            Iep.emptyDropdown(levelSelect, 'Level');
            Iep.emptyDropdown(statementSelect, 'Statement');
            var ppFocusAreaId = $(this).val();
            if (ppFocusAreaId) {
                $.get('/ieps/pp-subject-categories/' + ppFocusAreaId + '/ajax', function(data) {
                    $.each(JSON.parse(data), function(key, value) {
                        subjectCategorySelect
                            .append('<option value="' + key + '">' + value + '</option>');
                    });
                    subjectCategorySelect.select2();
                });
            }
        });
        $('[id^=ppSubjectCategory-]').on('select2:select', function (e) {
            var levelSelect =
                $(this).closest('div.pp-focus-area-dropdown').nextAll().find('[id^=ppLevel-]').first();
            var statementSelect =
                $(this).closest('div.pp-focus-area-dropdown').nextAll().find('[id^=ppStatement-]').first();
            Iep.emptyDropdown(levelSelect, 'Level');
            Iep.emptyDropdown(statementSelect, 'Statement');
            var ppSubjectCategoryId = $(this).val();
            if (ppSubjectCategoryId) {
                $.get('/ieps/pp-levels/' + ppSubjectCategoryId + '/ajax', function(data) {
                    $.each(JSON.parse(data), function(key, value) {
                        levelSelect
                            .append('<option value="' + key + '">' + value + '</option>');
                    });
                    levelSelect.select2();
                });
            }
        });
        $('[id^=ppLevel-]').on('select2:select', function (e) {
            var statementSelect =
                $(this).closest('div.pp-focus-area-dropdown').nextAll().find('[id^=ppStatement-]').first();
            Iep.emptyDropdown(statementSelect, 'Statement');
            var ppLevelId = $(this).val();
            if (ppLevelId) {
                $.get('/ieps/pp-statements/' + ppLevelId + '/ajax', function(data) {
                    $.each(JSON.parse(data), function(key, value) {
                        statementSelect
                            .append('<option value="' + key + '">' + value + '</option>');
                    });
                    statementSelect.select2();
                });
            }
        });
    },

    emptyDropdown: function(select, text) {
        select.empty().focus().append('<option value="0">Untitled Passport ' + text + '</option>').select2();
    },

    bindComments: function() {
        $('.prediction-comment').click(function() {
            var targetId = $(this).data('target');
            var target = $('#' + targetId);
            target.slideToggle('fast');
        });
    },

    bindTargetSubmit: function() {
        $('.iep-target-submit').on('click', function(e) {
            //e.stopPropagation();
            $('#iep-submit').trigger('click');
            return false;
        });
    },

    bindSubmit: function() {
        $('#iep-submit').on('click', function(e) {
            var passport = $('#type-select').find("option:selected").html().includes('Pupil Passport');
            var select = $('#iep-pupil');
            var noPupil = select.val() === undefined || select.val() == '' || select.val() == null;
            /* multiple focus areas/statuses across multiple targets
            var select = $('[id^=focusArea-]');
            var noFocusArea = select.val() === undefined || select.val() == '' || select.val() == null || select.val() == 0;
            var select = $('[id^=status-]');
            var noStatus = select.val() === undefined || select.val() == '' || select.val() == null || select.val() == 0;
            */
            var noFocusArea = false;
            $('[id^=focusArea-]').each(function() {
                select = $(this);
                if (!noFocusArea) {
                    noFocusArea = select.val() === undefined || select.val() == '' || select.val() == null || select.val() == 0;
                }
                if (noFocusArea) {
                    return false;
                }
            });
            var noPpFocusArea = false;
            $('[id^=ppFocusArea-]').each(function() {
                select = $(this);
                if (!noPpFocusArea) {
                    noPpFocusArea = select.val() === undefined || select.val() == '' || select.val() == null || select.val() == 0;
                }
                if (noPpFocusArea) {
                    return false;
                }
            });
            var noStatus = false;
            $('[id^=status-]').each(function() {
                var id = $(this).attr('id');
                if (/status-\d+$/.test(id)) {
                    select = $(this);
                    if (!noStatus) {
                        noStatus = select.val() === undefined || select.val() == '' || select.val() == null || select.val() == 0;
                    }
                    if (noStatus) {
                        return false;
                    }
                }
            });
            if (noPupil || !passport && noFocusArea || noStatus || passport && noPpFocusArea) {
                e.preventDefault();
                switch (true) {
                    case noPupil:
                        alert('Please select a pupil before continuing.');
                        break;
                    case !passport && noFocusArea:
                    case passport && noPpFocusArea:
                        alert('Please select a Focus Area for each Target before continuing.');
                        break;
                    case noStatus:
                        alert('Please select a Status for each Target before continuing.');
                        break;
                    default:
                        break;
                }
            } else {

                var textareaContent = true;
                /* do not validate Target, Strategy, Success Criteria and Evaluation
                //$('textarea[class!="evaluation"]').each(function() {
                $('textarea').not('.evaluation').each(function() {
                    if ($(this).val() == '') {
                        textareaContent = false;
                        return false;
                    }
                });
                */
                if (textareaContent) {
                    var btn = $(this);
                    var html = '<img src="/images/ajax-loader.gif" class="btn-spinner"> Please wait...';
                    var form = $('#iepFormForm');
                    var data = form.serialize();
                    var url = form.attr('action');

                    btn.html(html);
                    /* disable button in form's submit event
                    btn.attr('disabled', true);

                    form.submit();
                    */
                    form.submit(function() {
                        //btn.html(html);
                        //btn.attr('disabled', true);
                        $('#iep-submit').prop('disabled', true);
                    });
                }
            }
        });
    },

    bindFocusCheck: function() {
        $('#focus').click(function() {
            $('#equals').text('');
            $('#iep-focus-equals').remove();
            var input = $(this);
            if (input.is(':checked')) {
                var focus = $('#iep-focus-select').find(":selected").text();
                if (focus == 'focus area' || focus == 'status')
                {
                    Iep.focusEqualsDropdown(encodeURIComponent(focus));
                }
                $('#focus-actions').slideDown('fast');
                return true;
            }
            $('#focus-actions').slideUp('fast');
        });

        $('#iep-focus-select').on('change', function() {
            $('#equals').text('');
            $('#iep-focus-equals').remove();
            var focus = $('#iep-focus-select').find(":selected").text();
            if (focus == 'focus area' || focus == 'status')
            {
                Iep.focusEqualsDropdown(encodeURIComponent(focus));
            }
        });
    },

    focusEqualsDropdown: function(focus) {
        $('#iep-focus-select').after(
            '<span id="equals"> equals</span>\n' +
            '<select id="iep-focus-equals" name="focus_values[]" multiple="multiple"\n' +
            '   style="position: relative; top: 80px; margin-top: -80px; z-index: 1">\n' +
            '   <option value="" class="default-option" selected="">All</option>\n'
        );
        $.get('/reports/ieps/' + focus + '/ajax', function (data) {
            // $.each(JSON.parse(data), function(key, value) {
            $.each(data, function (key, item) {
                $('#iep-focus-equals').append('<option value="' + key + '">' + item + '</option>');
            });
        });
        $('#iep-focus-equals').after('</select>');
    },

    bindPupilSelect: function() {
      $('.iep-pupil-list').change(function() {
          var pupilId = $(this).val();
          $.get('/admin/pupils/' + pupilId + '/info', function(data) {
              $('#pupil-info-row').html(data);
          });
      });
    },

    bindSavePropertyInModal: function() {
        // bind event to add button in items.blade.php
        $('.add-zz-dropdown-property, .add-zz-checkbox-property').on('click', function() {
            var zzProperty = $(this).data('zz-property');
            // place actual dropdown field (zz4nn_dropdown) into all selector add modals
            $('.iep-property-add').each(function() {
                if (typeof $(this).data('zz-property') !== 'undefined') {
                    $(this).data('zz-property', zzProperty);
                }
            });
        });
    },

    bindBuildDropdownInModal: function() {
        // bind event to manage button in items.blade.php
        $('.manage-zz-dropdown-property').on('click', function() {
            // get select element in manage modal
            var select = $('#manage-zz-dropdown-select');
            var zzProperty = $(this).data('zz-property');
            // place actual dropdown field (zz4nn_dropdown) into all selector add modals
            $('.iep-property-add').each(function() {
                if (typeof $(this).data('zz-property') !== 'undefined') {
                    $(this).data('zz-property', zzProperty);
                }
            });
            var selectedId = Iep.getDropdownSelectedInForm($(this));
            select.empty();
            //select.append('<option selected disabled>Click to see list of ' + property + 's</option>');
            select.append('<option selected disabled>Click to see list of ' + zzProperty + 's</option>');
            $.get('/ieps/zz-dropdowns/' + zzProperty + '/ajax', function(data) {
                $.each(JSON.parse(data), function(key, value) {
                    if (key != 0) {
                        if (key != selectedId) {
                            select.append('<option value="' + key + '">' + value + '</option>');
                        } else {
                            select.append('<option value="' + key + '" disabled>' + value + '</option>');
                        }
                    } else {
                        // the first element  has option attributes: selected disabled
                        //select.append(value);
                    }
                });
                select.select2();
            });
            Iep.setDropdownInModal($(this));
        });
    },

    getDropdownSelectedInForm: function(manageButton) {
        var selectId = manageButton.data('select');
        var select = $('#' + selectId);
        var option = select.find(':selected');
        return option.val();
    },

    bindBuildCheckboxInModal: function() {
        $('.manage-zz-checkbox-property').on('click', function() {
            var checkbox = $('#manage-zz-checkbox-checkbox');
            var zzProperty = $(this).data('zz-property');
            $('.iep-property-add').each(function() {
                if (typeof $(this).data('zz-property') !== 'undefined') {
                    $(this).data('zz-property', zzProperty);
                }
            });
            var checkedId = Iep.getCheckedCheckboxInForm($(this));
            $.get('/ieps/zz-checkboxes/' + zzProperty + '/ajax', function(data) {
                checkbox.empty();
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys#browser_compatibility
                if (Object.keys(JSON.parse(data)).length) {
                    $.each(JSON.parse(data), function (key, value) {
                        if (key != 0) {
                            if (key != checkedId) {
                                checkbox.append('<div class="checkbox-container col-sm-24 col-24">' +
                                    '<label><input type="checkbox" class="" name="zz501_checkbox[]" ' +
                                    'id="zz501_checkbox' + key + '" placeholder="" value="' + key + '"> ' + value +
                                    '</label></div>');
                            } else {
                                checkbox.append('<div class="checkbox-container col-sm-24 col-24">' +
                                    '<label><input type="checkbox" class="" name="zz501_checkbox[]" ' +
                                    'id="zz501_checkbox' + key + '" placeholder="" ' +
                                    'value="' + key + '" disabled readonly> ' + value +
                                    '</label></div>');
                            }
                        } else {
                            // the first element  has option attributes: selected disabled
                            //select.append(value);
                        }
                    });
                    //select.select2();
                }
            });
            Iep.setCheckboxInModal($(this));
        });
    },

    getCheckedCheckboxInForm: function(manageButton) {
        var checkboxId = manageButton.data('checkbox');
        checkboxId = checkboxId.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
        var checkbox = $('#' + checkboxId);
        var option = checkbox.find('label').filter(function() {
            return $(this).text().search(/\*Manage\*/) > -1;
        });
        return option.find('input').val();
    },

    setPropertyTranslation: function(property) {
        property = property.toLowerCase();
        var text = '? ' + property + ' ? unknown';
        if (property == 'zz401_dropdown') {
            text = translatedZz401Dropdown;
        } else if (property == 'zz402_dropdown') {
            text = translatedZz402Dropdown;
        } else if (property == 'zz403_dropdown') {
            text = translatedZz403Dropdown;
        } else if (property == 'zz404_dropdown') {
            text = translatedZz404Dropdown;
        } else if (property == 'zz405_dropdown') {
            text = translatedZz405Dropdown;
        } else if (property == 'zz406_dropdown') {
            text = translatedZz406Dropdown;
        } else if (property == 'zz407_dropdown') {
            text = translatedZz407Dropdown;
        } else if (property == 'zz408_dropdown') {
            text = translatedZz408Dropdown;
        } else if (property == 'zz409_dropdown') {
            text = translatedZz409Dropdown;
        } else if (property == 'zz501_checkbox') {
            text = translatedZz501Checkbox;
        } else if (property == 'zz502_checkbox') {
            text = translatedZz502Checkbox;
        } else if (property == 'zz503_checkbox') {
            text = translatedZz503Checkbox;
        } else if (property == 'zz504_checkbox') {
            text = translatedZz504Checkbox;
        } else if (property == 'zz505_checkbox') {
            text = translatedZz505Checkbox;
        } else if (property == 'zz506_checkbox') {
            text = translatedZz506Checkbox;
        } else if (property == 'zz507_checkbox') {
            text = translatedZz507Checkbox;
        } else if (property == 'zz508_checkbox') {
            text = translatedZz508Checkbox;
        } else if (property == 'zz509_checkbox') {
            text = translatedZz509Checkbox;
        }
        return text;
    },

    bindDisableContextmenu: function() {
        $('input[name*="checkbox][]"]').contextmenu(function(e) {
            return false;
        });
    },

    bindSetManage: function() {
        $('input[name*="checkbox][]"]').contextmenu(function(e) {
            var div = $(this).closest('div.checkbox-container');
            var divs = div.siblings();
            divs.each(function (i) {
                label = $('label', $(this));
                var html = label.html();
                if (html.search(' *Manage*') > -1) {
                    html = html.replace(' *Manage*', '');
                    label.html(html);
                }
            });
            var label = $(this).parent();
            var html = label.html();
            if (html) {
                if (html.search(' *Manage*') < 0) {
                    html = html + ' *Manage*';
                } else {
                    html = html.replace(' *Manage*', '');
                }
                label.html(html);
            }
            Iep.bindSetManage();
            return false;
        });
    },

    bindAddProperty: function() {
      $('.iep-property-add').click(function(e) {
          var property = $(this).data('property');
          var name = $('#' + property).val();
          if (property == 'focus-area') {
              var translatedProperty = translatedFocusArea;
          } else if (property == 'type') {
              var translatedProperty = translatedType;
          }
          if (property == 'zz-dropdown' || property == 'zz-checkbox') {
              var zzProperty = $(this).data('zz-property');
              var translatedProperty = Iep.setPropertyTranslation(zzProperty);
              Iep.currentZzProperty = zzProperty;
          }
          Iep.currentProperty = property;
          if (property == 'status') {
              translatedProperty = translatedStatus;
          }
          $.get('/ieps/' + property + '/add?name=' + name + '&property=' + zzProperty, function(data) {
            if (data.success) {
                alert(translatedProperty + ' added successfuly!');
                $('#' + property + '-modal').modal('hide');
                if (property != 'zz-checkbox') {
                    Iep.bindPropertySelect();
                } else {
                    Iep.bindPropertyCheckbox();
                }
            } else {
                alert('Action not successful, please try again.');
            }
          });
      });
    },

    bindCancel: function() {
        $('.delete-cancel').click(function() {
            Iep.toggleManageModal(false);
        });
    },

    bindDelete: function() {
        $('.iep-property-delete').click(function() {
            if (!$(this).hasClass('confirm')) {
                Iep.toggleManageModal(true);
                return;
            }
            var originalId = Iep.currentItem['id'];
            var property = Iep.currentProperty;
            var newId = $('#manage-' + property + '-select').val();
            Iep.newItemId = newId;
            if (property == 'focus-area') {
                var translatedProperty = translatedFocusArea;
            } else if (property == 'type') {
                var translatedProperty = translatedType;
            } else if (property == 'status') {
                var translatedProperty = translatedStatus;
            } else if (property == 'zz-dropdown' || property == 'zz-checkbox') {
                var zzProperty = Iep.currentZzProperty;
                var translatedProperty = Iep.setPropertyTranslation(zzProperty);
                if (property == 'zz-checkbox') {
                    var newId = 0;
                    $('#manage-' + property + '-checkbox').find('input:checked').map(function() {
                        newId = this.value;
                        return false;
                    })
                }
            }
            $.get('/ieps/' + property + '/delete?original_id=' + originalId + '&new_id=' + newId +
                '&property=' + zzProperty, function(data) {
                if (data.success) {
                    alert(translatedProperty + ' successfully deleted.');
                    $('#manage-' + property + '-modal').modal('hide');
                    Iep.deletedId = originalId;
                    if (property != 'zz-checkbox') {
                        Iep.bindPropertySelect();
                    } else {
                        Iep.bindPropertyCheckbox();
                    }
                    return;
                }
                alert('Action not successful. Please try again.');
            })
        });
    },

    bindManageIepPropertyButtons: function() {
        $('.manage-iep-property').click(function() {
            Iep.setDropdownInModal($(this));
        });
    },

    setDropdownInModal: function(manageButton) {
        var selectId = manageButton.data('select');
        var property = manageButton.data('property');
        Iep.currentProperty = property;
        if (property == 'focus-area') {
            var translatedProperty = translatedFocusArea;
        } else if (property == 'type') {
            var translatedProperty = translatedType;
            Iep.toggleManageModal(false);
        } else if (property == 'status') {
            var translatedProperty = translatedStatus;
        } else if (property == 'zz-dropdown') {
            var zzProperty = manageButton.data('zz-property');
            var translatedProperty = Iep.setPropertyTranslation(zzProperty);
            Iep.currentZzProperty = zzProperty;
        }
        // var currentItem = Iep.currentFocusArea;
        // if (property == 'status') {
        //     translatedProperty = translatedStatus;
        //     currentItem = Iep.currentStatus
        // }
        var typeSelect = $('#manage-' + property+ '-select');
        //var focusAreaElement =  $('#manage-' + property + '-name');
        var propertyElement =  $('#manage-' + property + '-name');
        //focusAreaElement.val('').attr('placeholder', 'New name');
        propertyElement.val('').attr('placeholder', 'New name');
        var select = $('#' + selectId);
        var option = select.find(':selected');
        Iep.currentItem['id'] = option.val();
        Iep.currentItem['name'] = option.text();
        $('#manage-' + property + '-title').html('Manage ' + translatedProperty + ': ' + Iep.currentItem['name']);
        typeSelect.find('option').attr('disabled', false);
        typeSelect.find('option[value="' + Iep.currentItem['id'] +'"]').attr('disabled', true);
    },

    setCheckboxInModal: function(manageButton) {
        var checkboxId = manageButton.data('checkbox');
        var property = manageButton.data('property');
        Iep.currentProperty = property;
        if (property == 'zz-checkbox') {
            var zzProperty = manageButton.data('zz-property');
            var translatedProperty = Iep.setPropertyTranslation(zzProperty);
            Iep.currentZzProperty = zzProperty;
        }
        /* doing this in $.get in bindBuildCheckboxInModal instead since asynchronous
        var typeCheckbox = $('#manage-' + property + '-checkbox');
        */
        var propertyElement =  $('#manage-' + property + '-name');
        propertyElement.val('').attr('placeholder', 'New name');
        checkboxId = checkboxId.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
        var checkbox = $('#' + checkboxId);
        //var option = select.find(':selected');
        var option = checkbox.find('label').filter(function() {
           return $(this).text().search(/\*Manage\*/) > -1;
        });
        Iep.currentItem['id'] = option.find('input').val();
        Iep.currentItem['name'] = option.text().replace('\*Manage\*', '').trim();
        $('#manage-' + property + '-title').html('Manage ' + translatedProperty + ': ' + Iep.currentItem['name']);
        /* doing this in $.get in bindBuildCheckboxInModal instead since asynchronous
        typeCheckbox.find('input').removeAttr('disabled');
        typeCheckbox.find('input[value="' + Iep.currentItem['id'] +'"]').attr('disabled', true);
        */
    },

    bindManageModal: function() {
        $('.iep-property-modal').on('hidden.bs.modal', function() {
            Incidents.toggleManageModal();
        });
    },

    toggleManageModal: function(remove) {
        var property = Iep.currentProperty;
        if (property == 'focus-area') {
            var translatedProperty = translatedFocusArea;
        } else if (property == 'type') {
            var translatedProperty = translatedType;
            $('#manage-' + property + '-name').hide();
        }
        if (property == 'status') {
            translatedProperty = translatedStatus;
        }
        var selector = 'select';
        if (property == 'zz-dropdown' || property == 'zz-checkbox') {
            var zzProperty = Iep.currentZzProperty;
            var translatedProperty = Iep.setPropertyTranslation(zzProperty);
            if (property == 'zz-checkbox') {
                var selector = 'checkbox';
            }
        }
        if (remove) {
            var deleteBtn = $('#'+ property +'-delete');
            deleteBtn.removeClass('btn-secondary').addClass('btn-danger').addClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Confirm');
            if (property == 'focus-area' || property == 'status' ||
                property == 'zz-dropdown' || property == 'zz-checkbox') {
                $('#' + property + '-delete-text').html('Select a new ' + translatedProperty + ' to move ' + translatedTarget + 's  with this ' + translatedProperty + ' to.').show();
                $('#manage-' + property + '-' + selector + '-container').slideDown('fast');
                $('#manage-' + property + '-name').slideUp('fast');
            }
            $('#' + property + '-delete-cancel').show();
            $('#manage-' + property + '-save').hide();
            return;
        }
        $('#' + property + '-delete').removeClass('btn-danger').addClass('btn-secondary').removeClass('confirm').html('<i class="fa fa-trash" aria-hidden="true"></i> Delete');
        $('#' + property + '-delete-text').html('').hide();
        $('#manage-' + property + selector + '-container').slideUp('fast');
        $('#manage-' + property + '-name').slideDown('fast');
        $('#' + property + '-delete-cancel').hide();
        $('#manage-' + property + '-save').show();
    },

    bindManagePropertySave: function() {
        $('.iep-property-save').click(function() {
            var property = Iep.currentProperty;
            var nameInput = $('#manage-' + property + '-name');
            if (nameInput.val() != '') {
                // ??? where is select subsequently used ???
                var select = $('#manage-' + property + '-select');
                var name = nameInput.val();
                var id = Iep.currentItem['id'];
                if (property == 'focus-area') {
                    var translatedProperty = translatedFocusArea;
                } else if (property == 'type') {
                    var translatedProperty = translatedType;
                } else if (property == 'status') {
                    var translatedProperty = translatedStatus;
                } else if (property == 'zz-dropdown' || property == 'zz-checkbox') {
                    var zzProperty = Iep.currentZzProperty;
                    var translatedProperty = Iep.setPropertyTranslation(zzProperty);
                    if (property == 'zz-checkbox') {
                        // ??? where is select subsequently used ???
                        select = $('manage-' + property + '-checkbox');
                    }
                }
                name = encodeURIComponent(name);
                $.get('/ieps/' + property + '/rename?id=' + id + '&name=' + name +
                    '&property=' + zzProperty, function(res) {
                    if (res.success) {
                        alert(translatedProperty + ' updated successfully!');
                        nameInput.val('');
                        $('#manage-' + property +' -modal').modal('hide');
                        if (property != 'zz-checkbox') {
                            Iep.bindPropertySelect();
                        } else {
                            Iep.bindPropertyCheckbox();
                        }
                        return;
                    }
                    alert('Action not successful. Please try again.');
                });
            }
        });
    },

    bindPropertySelect: function () {
        var property = Iep.currentProperty;
        var selects = $('.iep-focus-areas');
        var url = '/ieps/focus-areas';
        if (property == 'focus-area') {
            var translatedProperty = translatedFocusArea + 's';
        } else if (property == 'type') {
            selects = $('#type-select');
            url = '/ieps/types';
            var translatedProperty = translatedType + 's';
        }
        if (property == 'status') {
            selects = $('.iep-statuses');
            url = '/ieps/statuses';
            translatedProperty = translatedStatuses;
        }
        if (property == 'zz-dropdown') {
            var zzProperty = Iep.currentZzProperty;
            selects = $('.iep-zz-dropdowns-' + zzProperty.substring(3, 5));
            url = '/ieps/zz-dropdowns?property=' + zzProperty;
            var translatedProperty = Iep.setPropertyTranslation(zzProperty) + 's';
        }
        $.get(url, function(propertyItems) {
            var manageSelect = $('#manage-'+ property +'-select');
            manageSelect.empty();
            propertyItems = App.sortProperties(propertyItems, false);
            for (var x = 0; x < selects.length; x++) {
                var select = $(selects[x]);
                var currentId = select.val();
                select.empty();
                var item = '<option value="" selected disabled>Click to see list of ' +  translatedProperty  + '</option>';
                select.append(item);
                for (var z = 0; z < propertyItems.length; z++) {
                    var selectOption = '';
                    var disabled = '';
                    var propertyItem = propertyItems[z];
                    if (propertyItem[0] == currentId || (Iep.deletedId == currentId && propertyItem[0] == Iep.newItemId)) {
                        selectOption = 'selected';
                        // disabled = 'disabled';
                    }
                    item = '<option value="'+ propertyItem[0] +'"' + selectOption + '>'+ propertyItem[1] +'</option>';
                    select.append(item);
                    // item = '<option value="'+ focusArea[0] +'"' + selectOption + ' ' + disabled + '>'+ focusArea[1] +'</option>';
                    if (x < 1) {
                        manageSelect.append(item);
                    }
                }
            }
            Iep.deletedId = '';
        });
    },

    bindPropertyCheckbox: function () {
        var property = Iep.currentProperty;
        var checkboxesParent;
        var checkboxes;
        var url = '/ieps/zz-checkboxes';
        if (property == 'zz-checkbox') {
            var zzProperty = Iep.currentZzProperty;
            // pick out the checkbox objects
            checkboxesParent = $('.iep-zz-checkboxes-' + zzProperty.substring(3, 5));
            checkboxes = checkboxesParent.children();
            url = '/ieps/zz-checkboxes?property=' + zzProperty;
            var translatedProperty = Iep.setPropertyTranslation(zzProperty) + 's';
        }
        $.get(url, function(propertyItems) {
            var manageCheckbox = $('#manage-'+ property +'-checkbox');
            manageCheckbox.empty();
            propertyItems = App.sortProperties(propertyItems, false);
            for (var x = 0; x < checkboxes.length; x++) {
                var checkDiv = $(checkboxes[x]);
                // look at the parent div of the checkboxes
                var name = checkDiv.parent().attr('id').substring(9);
                var colsClass = 'checkbox-container col-sm-';
                if (propertyItems.length == 2) {
                    colsClass = colsClass.concat('12 col-24 pull-left');
                } else if (propertyItems.length == 3) {
                    colsClass = colsClass.concat('8 col-24 pull-left');
                } else {
                    colsClass = colsClass.concat('24 col-24');
                }
                var currentIds = [];
                var checkCount = 0;
                // checkDiv is the individual checkbox; look under its parent div
                checkDiv.parent().find('input').each(function () {
                    if ($(this).is(':checked')) {
                        checkCount = currentIds.push($(this).val());
                    }
                });
            }
            // clear all checkboxes
            checkboxesParent.empty();
            for (var z = 0; z < propertyItems.length; z++) {
                var checkOption = '';
                var propertyItem = propertyItems[z];
                for (var y = 0; y < checkCount; y++) {
                    if (propertyItem[0] == currentIds[y] || (Iep.deletedId == currentIds[y] && propertyItem[0] == Iep.newItemId)) {
                        checkOption = 'checked';
                    }
                }
                // appending an open div creates a closed div
                //checkDiv.append('<div class="' + colsClass + '">');
                if (checkOption != 'checked') {
                    // append to parent div of checkboxes
                    checkboxesParent.append('<div class="' + colsClass + '">' +
                        '<label><input type="checkbox" class="" name="' + name + '[]" ' +
                        'id="' + name + propertyItem[0] + '" placeholder="" value="' + propertyItem[0] + '"> ' +
                        propertyItem[1] + '</label></div>');
                } else {
                    checkboxesParent.append('<div class="' + colsClass + '">' +
                        '<label><input type="checkbox" class="" name="' + name + '[]" ' +
                        'id="' + name + propertyItem[0] + '" placeholder="" value="' + propertyItem[0] + '" ' +
                        'checked="checked"> ' + propertyItem[1] + '</label></div>');
                }
                // appending an open div creates a closed div
                //checkDiv.append('</div>');
            }
            Iep.deletedId = '';
            Iep.bindSetManage();
        });
    },

    bindLoadIepView: function () {
        $('.iep-view').click(function () {
            window.location = $(this).data('href');
        });
    },

    bindAddTarget: function () {
        $('.btn-add-target').click(function () {
            var count = $('.target').length;
            var items = $('#items');
            var passport = $('#type-select').find("option:selected").html().includes('Pupil Passport');
            $.get('/ieps/ajax?count=' + count + '&passport=' + passport, function(data) {
                $('#add-container').remove();
                items.append(data);
                //var newDropZone = items.find('.dropzone:last');
                $('.select2').select2();
                //Forms.bindDropzone(newDropZone);
                $('[id^=target-]:last').each(function() {
                    $(this).find('.dropzone').each(function () {
                        Forms.bindDropzone($(this));
                    });
                });
                Iep.bindAddTarget();
                Iep.bindRemoveTarget();
                Iep.bindManageIepPropertyButtons();
                Iep.bindPassportChange();
                Iep.bindTargetSubmit();
            });
        });
    },

    bindRemoveTarget: function() {
        $('.btn-remove-target').off('click').on('click', function() {
            var btn = $(this);
            var iepTargets = $('.iep-target');
            var targetCount = iepTargets.length;
            if (targetCount > 1) {
                $('.iep-target:last').remove();
                targetCount--;
            }
            if (targetCount == 1 || targetCount == existingItems) {
                $('.btn-remove-target').addClass('hidden');
            }
            // if ((typeof existingItems !== 'undefined' && targetCount > existingItems) || targetCount > 1) {
            //     iepTargets.last().remove();
            //     targetCount--;
            // }
            // if ((typeof existingItems !== 'undefined' && targetCount > existingItems) || targetCount == 1) {
            //     $('.btn-remove-target').addClass('hidden');
            // }
        });
    },

    //Author: Chris Leake
    bindTypeFilter: function() {
        $('.iep-type-select').change(function () {
            var iepTargetTypeId = $(this).val();
            /*
            var url = window.location.href;
            if (!document.location.search.length) {
                window.location.href = url + '?type=' + iepTargetTypeId;
            } else {
                window.location.href = url + '&type=' + iepTargetTypeId;
            }
            */
            /*
             * queryParameters -> handles the query string parameters
             * queryString -> the query string without the fist '?' character
             * re -> the regular expression
             * m -> holds the string matching the regular expression
             */
            var queryParameters = {},
                queryString = location.search.substring(1),
                re = /([^&=]+)=([^&]*)/g,
                m;

            // Creates a map with the query string parameters
            while (m = re.exec(queryString)) {
                queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
            }

            // Add new parameters or update existing ones
            //queryParameters['newParameter'] = 'new parameter';
            //queryParameters['existingParameter'] = 'new value';
            queryParameters['type'] = iepTargetTypeId;

            /*
             * Replace the query portion of the URL.
             * jQuery.param() -> create a serialized representation of an array or
             *     object, suitable for use in a URL query string or Ajax request.
             */
            location.search = $.param(queryParameters); // Causes page to reload
        });
    },

};
